export default __webpack_public_path__ + "static/media/ReWORX-BrandName.f6fa4ea7.png";